import {makePostBeneficiaryAddressV4} from 'main/factories/usecases';
import {formValuesToAddressV4Item} from '../utils/addressV4Payload';
import {PostFavoriteAddressServiceParams} from '../types';

export async function postFavoriteAddress({
	data,
	reverseGeocodeData,
	signal,
}: PostFavoriteAddressServiceParams) {
	const latLng = reverseGeocodeData
		? {latitude: reverseGeocodeData.latitude, longitude: reverseGeocodeData.longitude}
		: null;
	const addressItem = formValuesToAddressV4Item(data, latLng);
	await makePostBeneficiaryAddressV4().post({addresses: [addressItem], signal});
}
